/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "./request";
const mockUrl_0_0_0_0 = "http://yapi.yishou.com/mock/128";
const devUrl_0_0_0_0 = "http://erp38.yishou.com/";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 [导出白名单用户数据|导出demo↗](http://yapi.yishou.com/project/128/interface/api/34003) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/WavePickingTempSummary/exportUserWhite`
 * @更新时间 `2022-08-11 13:53:23`
 */
const exportUserWhiteRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePickingTempSummary/exportUserWhite",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["is_demo"],
        properties: { is_demo: { type: "string", description: "是否下载模板 0 否 1 是" } },
    },
    responseDataJsonSchema: { type: "object", properties: { file: { type: "string" } } },
    requestFunctionName: "exportUserWhite",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导出白名单用户数据|导出demo↗](http://yapi.yishou.com/project/128/interface/api/34003) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/WavePickingTempSummary/exportUserWhite`
 * @更新时间 `2022-08-11 13:53:23`
 */
export const exportUserWhite = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(exportUserWhiteRequestConfig, requestData), ...args);
};
exportUserWhite.requestConfig = exportUserWhiteRequestConfig;
/**
 * 接口 [导入更新白名单用户↗](http://yapi.yishou.com/project/128/interface/api/34004) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/WavePickingTempSummary/importUserWhite`
 * @更新时间 `2022-08-11 14:00:11`
 */
const importUserWhiteRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePickingTempSummary/importUserWhite",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "导入文件", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "importUserWhite",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导入更新白名单用户↗](http://yapi.yishou.com/project/128/interface/api/34004) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/WavePickingTempSummary/importUserWhite`
 * @更新时间 `2022-08-11 14:00:11`
 */
export const importUserWhite = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importUserWhiteRequestConfig, requestData), ...args);
};
importUserWhite.requestConfig = importUserWhiteRequestConfig;
/**
 * 接口 [改标列表-改标类型修改↗](http://yapi.yishou.com/project/128/interface/api/34005) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/GaiBiao/updateGbType`
 * @更新时间 `2022-09-02 10:13:24`
 */
const updateGbTypeRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/updateGbType",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["id", "type"],
        properties: { id: { type: "string", description: "id" }, type: { type: "string", description: "类型" } },
    },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "updateGbType",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [改标列表-改标类型修改↗](http://yapi.yishou.com/project/128/interface/api/34005) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/GaiBiao/updateGbType`
 * @更新时间 `2022-09-02 10:13:24`
 */
export const updateGbType = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateGbTypeRequestConfig, requestData), ...args);
};
updateGbType.requestConfig = updateGbTypeRequestConfig;
/**
 * 接口 [改标列表-删除改标记录↗](http://yapi.yishou.com/project/128/interface/api/34006) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/GaiBiao/delGbInputRecord`
 * @更新时间 `2022-09-02 10:12:53`
 */
const delGbInputRecordRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/delGbInputRecord",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: { type: "object", required: ["id"], properties: { id: { type: "string" } } },
    responseDataJsonSchema: { type: "object", properties: {} },
    requestFunctionName: "delGbInputRecord",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [改标列表-删除改标记录↗](http://yapi.yishou.com/project/128/interface/api/34006) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/GaiBiao/delGbInputRecord`
 * @更新时间 `2022-09-02 10:12:53`
 */
export const delGbInputRecord = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(delGbInputRecordRequestConfig, requestData), ...args);
};
delGbInputRecord.requestConfig = delGbInputRecordRequestConfig;
/**
 * 接口 [改标用户汇总（编辑|添加）↗](http://yapi.yishou.com/project/128/interface/api/34007) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/WavePickingTempSummary/labelUserSetting`
 * @更新时间 `2022-08-11 14:23:47`
 */
const labelUserSettingRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/WavePickingTempSummary/labelUserSetting",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: true,
    requestDataJsonSchema: { type: "object", required: [], properties: {} },
    responseDataJsonSchema: {},
    requestFunctionName: "labelUserSetting",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [改标用户汇总（编辑|添加）↗](http://yapi.yishou.com/project/128/interface/api/34007) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @请求头 `POST /erp/WavePickingTempSummary/labelUserSetting`
 * @更新时间 `2022-08-11 14:23:47`
 */
export const labelUserSetting = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(labelUserSettingRequestConfig, requestData), ...args);
};
labelUserSetting.requestConfig = labelUserSettingRequestConfig;
/**
 * 接口 [标库存列表↗](http://yapi.yishou.com/project/128/interface/api/34155) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/leadingLabelList`
 * @更新时间 `2022-09-13 11:47:40`
 */
const leadingLabelListRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/leadingLabelList",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            page: { type: "string", description: '"1"' },
            page_size: { type: "string", description: '"10"' },
            user_id: { type: "string", description: '"2327244"' },
            supply_id: { type: "string", description: '"123456"' },
            space_txt: { type: "string", description: '"GB113"' },
            type: { type: "string", description: '"1"' },
            supply_name: { type: "string" },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            count: { type: "integer", description: "89" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: { type: "string", description: '"1"' },
                        type: { type: "string", description: '"1"' },
                        user_id: { type: "string", description: '"2327244"' },
                        supply_id: { type: "string" },
                        space_txt: { type: "string", description: '"GB113"' },
                        big_num: { type: "string", description: '"0"' },
                        medium_num: { type: "string", description: '"0"' },
                        small_num: { type: "string", description: '"0"' },
                        water_mark_num: { type: "string", description: '"0"' },
                        tag_num: { type: "string", description: '"0"' },
                        supply_name: { type: "string" },
                        imgs: { type: "array", description: "[]" },
                    },
                    additionalProperties: false,
                },
                description: '[{"id":"1","type":"1","user_id":"2327244","supply_id":"","space_txt":"GB113","big_num":"0","medium_num":"0","small_num":"0","water_mark_num":"0","tag_num":"0","supply_name":"","imgs":[]}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "leadingLabelList",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [标库存列表↗](http://yapi.yishou.com/project/128/interface/api/34155) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/leadingLabelList`
 * @更新时间 `2022-09-13 11:47:40`
 */
export const leadingLabelList = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(leadingLabelListRequestConfig, requestData), ...args);
};
leadingLabelList.requestConfig = leadingLabelListRequestConfig;
/**
 * 接口 [标入库↗](http://yapi.yishou.com/project/128/interface/api/34158) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/labelStockIn`
 * @更新时间 `2022-09-13 13:37:00`
 */
const labelStockInRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/labelStockIn",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            id: { type: "string", description: '"1"' },
            big_num: { type: "string", description: '"1"' },
            medium_num: { type: "string", description: '"2"' },
            small_num: { type: "string", description: '"3"' },
            water_mark_num: { type: "string", description: '"4"' },
            tag_num: { type: "string", description: '"5"' },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "labelStockIn",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [标入库↗](http://yapi.yishou.com/project/128/interface/api/34158) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/labelStockIn`
 * @更新时间 `2022-09-13 13:37:00`
 */
export const labelStockIn = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(labelStockInRequestConfig, requestData), ...args);
};
labelStockIn.requestConfig = labelStockInRequestConfig;
/**
 * 接口 [修改标数量↗](http://yapi.yishou.com/project/128/interface/api/34160) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/updateLabelNum`
 * @更新时间 `2022-09-13 13:45:45`
 */
const updateLabelNumRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/updateLabelNum",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            id: { type: "string", description: '"1"' },
            space_txt: { type: "string", description: '"GB113"' },
            big_num: { type: "string", description: '"1"' },
            medium_num: { type: "string", description: '"2"' },
            small_num: { type: "string", description: '"3"' },
            water_mark_num: { type: "string", description: '"4"' },
            tag_num: { type: "string", description: '"5"' },
            imgs: {
                type: "array",
                items: { type: "string", description: '"oss/usersLabelExample/img/202006/19/15925483045eec5bd0b334f.JPG"' },
                description: '["oss/usersLabelExample/img/202006/19/15925483045eec5bd0b334f.JPG"]',
            },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "updateLabelNum",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [修改标数量↗](http://yapi.yishou.com/project/128/interface/api/34160) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/updateLabelNum`
 * @更新时间 `2022-09-13 13:45:45`
 */
export const updateLabelNum = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(updateLabelNumRequestConfig, requestData), ...args);
};
updateLabelNum.requestConfig = updateLabelNumRequestConfig;
/**
 * 接口 [创建供应商仓位↗](http://yapi.yishou.com/project/128/interface/api/34161) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/createSupplySpace`
 * @更新时间 `2022-09-13 14:04:00`
 */
const createSupplySpaceRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/createSupplySpace",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            space_txt: { type: "string", description: '"S110"' },
            big_num: { type: "string", description: '"1"' },
            medium_num: { type: "string", description: '"2"' },
            small_num: { type: "string", description: '"3"' },
            water_mark_num: { type: "string", description: '"4"' },
            tag_num: { type: "string", description: '"5"' },
            imgs: {
                type: "array",
                items: { type: "string", description: '"oss/usersLabelExample/img/202006/19/15925483045eec5bd0b334f.JPG"' },
                description: '["oss/usersLabelExample/img/202006/19/15925483045eec5bd0b334f.JPG"]',
            },
            supply_id: { type: "string", description: '"15993"' },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: {},
    requestFunctionName: "createSupplySpace",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [创建供应商仓位↗](http://yapi.yishou.com/project/128/interface/api/34161) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/createSupplySpace`
 * @更新时间 `2022-09-13 14:04:00`
 */
export const createSupplySpace = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(createSupplySpaceRequestConfig, requestData), ...args);
};
createSupplySpace.requestConfig = createSupplySpaceRequestConfig;
/**
 * 接口 [查看日志↗](http://yapi.yishou.com/project/128/interface/api/34162) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/labelNumLog`
 * @更新时间 `2022-09-13 14:08:15`
 */
const labelNumLogRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/labelNumLog",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.json,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        properties: {
            id: { type: "string", description: '"1"' },
            page: { type: "string", description: '"1"' },
            page_size: { type: "string", description: '"10"' },
        },
        additionalProperties: false,
    },
    responseDataJsonSchema: {
        type: "object",
        properties: {
            count: { type: "integer", description: "8" },
            list: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        created_at: { type: "string", description: '"2022-09-13 13:57:01"' },
                        admin_name: { type: "string", description: '"林耀森"' },
                        content: { type: "string", description: '"库存调整。修改仓位:S110->GB113;"' },
                    },
                    additionalProperties: false,
                },
                description: '[{"created_at":"2022-09-13 13:57:01","admin_name":"林耀森","content":"库存调整。修改仓位:S110->GB113;"},{"created_at":"2022-09-13 13:56:51","admin_name":"林耀森","content":"库存调整。修改仓位:GB113->S110;"},{"created_at":"2022-09-13 13:47:13","admin_name":"林耀森","content":"库存调整。"},{"created_at":"2022-09-13 13:43:57","admin_name":"林耀森","content":"库存调整。修改仓位:GB114->GB113;修改改标示例图片;修改大标数量:1->1;修改中标数量:2->2;修改小标数量:3->3;修改洗水唛数量:4->4;修改吊牌数量:5->5;"},{"created_at":"2022-09-13 13:43:00","admin_name":"林耀森","content":"库存调整。修改仓位:GB113->GB114;修改大标数量:1->1;修改中标数量:2->2;修改小标数量:3->3;修改洗水唛数量:4->4;修改吊牌数量:5->5;"},{"created_at":"2022-09-13 13:42:33","admin_name":"林耀森","content":"库存调整。修改大标数量:2->1;修改中标数量:4->2;修改小标数量:6->3;修改洗水唛数量:8->4;修改吊牌数量:10->5;"},{"created_at":"2022-09-13 13:37:22","admin_name":"林耀森","content":"入库。修改大标数量:1->1;修改中标数量:2->2;修改小标数量:3->3;修改洗水唛数量:4->4;修改吊牌数量:5->5;"},{"created_at":"2022-09-13 13:35:12","admin_name":"林耀森","content":"入库。"}]',
            },
        },
        additionalProperties: false,
    },
    requestFunctionName: "labelNumLog",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [查看日志↗](http://yapi.yishou.com/project/128/interface/api/34162) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/labelNumLog`
 * @更新时间 `2022-09-13 14:08:15`
 */
export const labelNumLog = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(labelNumLogRequestConfig, requestData), ...args);
};
labelNumLog.requestConfig = labelNumLogRequestConfig;
/**
 * 接口 [导入批量修改↗](http://yapi.yishou.com/project/128/interface/api/34166) 的 **请求配置**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/importToUpdate`
 * @更新时间 `2022-09-13 14:28:06`
 */
const importToUpdateRequestConfig = {
    mockUrl: mockUrl_0_0_0_0,
    devUrl: devUrl_0_0_0_0,
    prodUrl: prodUrl_0_0_0_0,
    path: "/erp/GaiBiao/importToUpdate",
    method: Method.POST,
    requestHeaders: {},
    requestBodyType: RequestBodyType.form,
    responseBodyType: ResponseBodyType.json,
    dataKey: dataKey_0_0_0_0,
    paramNames: [],
    queryNames: [],
    requestDataOptional: false,
    requestDataJsonSchema: {
        type: "object",
        required: ["excel"],
        properties: { excel: { type: "file", description: "导入文件", tsType: "FileData" } },
    },
    responseDataJsonSchema: { type: "object" },
    requestFunctionName: "importToUpdate",
    queryStringArrayFormat: QueryStringArrayFormat.brackets,
    extraInfo: {},
};
/**
 * 接口 [导入批量修改↗](http://yapi.yishou.com/project/128/interface/api/34166) 的 **请求函数**
 *
 * @分类 [改标用户配置↗](http://yapi.yishou.com/project/128/interface/api/cat_3383)
 * @标签 `#3082改标库存管理`
 * @请求头 `POST /erp/GaiBiao/importToUpdate`
 * @更新时间 `2022-09-13 14:28:06`
 */
export const importToUpdate = /*#__PURE__*/ (requestData, ...args) => {
    return request(prepare(importToUpdateRequestConfig, requestData), ...args);
};
importToUpdate.requestConfig = importToUpdateRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/controller/userLabelConfig3383.js